import { EModalTypes } from 'react-gldn-kit';

import MoneyOperations from './components/MoneyOperations';
import Tournament from './components/Casino/CasinoTournaments/Tournament';
import CasinoTournamentPlayers from './components/Casino/CasinoTournaments/Players';
import TournamentRules from './components/Casino/CasinoTournaments/Rules';

import Languages from './components/Languages';
import SetNewPassword from './components/SetNewPassword';
import CasinoFavorites from './components/Casino/CasinoFavorites';
import CasinoProviders from './components/Casino/CasinoProviders';
import CalendarModal from './components/Calendar';
import InGameTickets from './components/Bettings/InGameTickets';
import ReferralCopyContent from './components/Referrals/ReferralCopyContent';
import ReferralWithdraw from './components/Referrals/ReferralWithdraw';
import ReferralFailure from './components/Referrals/ReferralFailure';
import ReferralSuccess from './components/Referrals/ReferralSuccess';
import PromoCodeActivateModal from './components/PromoCode/PromoCodeActivateModal';
import ClaimConfirmation from './components/ClaimConfirmation';
import { lazy } from 'react';
import BonusCabinet from 'pages/Profile/BonusCabinet';
import BonusInfo from './components/Bonuses/components/BonusInfo';
const PrizeModal = lazy(() => import('./components/PrizeModal'));
const MoneyComingPrize = lazy(() => import('./components/MoneyComingModal'));
const CancelBonus = lazy(() => import('./components/CancelBonus'));

const BonusPack = lazy(() => import('./components/BonusPack'));
const TransactionDetails = lazy(
  () => import('./components/TransactionDetails')
);
const CricketPrize = lazy(() => import('./components/CricketPrize'));
const LandingBonus = lazy(() => import('./components/LandingBonus'));
const ChickenBonus = lazy(() => import('./components/ChickenBonus'));

export const getComponentFn = (
  key: (typeof EModalTypes)[keyof typeof EModalTypes]
) => {
  console.info(key, 'key');
  switch (key) {
    case EModalTypes.ReferralCopyContent:
      return <ReferralCopyContent />;
    case EModalTypes.ReferralFailure:
      return <ReferralFailure />;
    case EModalTypes.ReferralSuccess:
      return <ReferralSuccess />;
    case EModalTypes.ReferralWithdraw:
      return <ReferralWithdraw />;
    // case EModalTypes.SetNewPassword:
    //   return <SetNewPassword />;
    case EModalTypes.MoneyOperations: // NOTICE: custom header ( need to change ?)
      return <MoneyOperations />;
    case EModalTypes.CasinoTournament:
      return <Tournament />;
    case EModalTypes.CasinoTournamentPlayers:
      return <CasinoTournamentPlayers />;
    case EModalTypes.TournamentRules:
      return <TournamentRules />;
    case EModalTypes.Languages:
      return <Languages />;
    case EModalTypes.CasinoFavorite:
      return <CasinoFavorites />;
    case EModalTypes.BonusPack:
      return <BonusPack />;
    case EModalTypes.CasinoProviders:
      return <CasinoProviders />;
    case EModalTypes.Calendar:
      return <CalendarModal />;
    case EModalTypes.TransactionDetails:
      return <TransactionDetails />;
    // NOTICE: need to do it ?
    // case EModalTypes.TransactionFilters:
    //   return <TransactionFilter />;
    case EModalTypes.Bonuses:
      return <BonusCabinet withoutTitle />;
    case EModalTypes.CancelBonus:
      return <CancelBonus />;
    case EModalTypes.ClaimConfirmation:
      return <ClaimConfirmation />;
    // Notice: remove it
    // case EModalTypes.ShortStories:
    //   return <ShortStories />;

    case EModalTypes.PromoCodeActivate:
      return <PromoCodeActivateModal />;
    case EModalTypes.BonusInfo:
      return <BonusInfo />;
    // bettings
    case EModalTypes.InGameTickets:
      return <InGameTickets />;

    case EModalTypes.Prize:
      return <PrizeModal />;
    case EModalTypes.MoneyComingPrize:
      return <MoneyComingPrize />;
    case EModalTypes.CricketPrize:
      return <CricketPrize />;
    case EModalTypes.LandingBonus:
      return <LandingBonus />;
    case EModalTypes.ChickenBonus:
      return <ChickenBonus />;

    default:
      return null;
  }
};
